<template>
  <div class="page mypage password_update pt-3">
    <p>現在お使いのパスワードを変更します。</p>
    <div class="mypage__body general-form">
      <form>
        <validation-observer v-slot="observer">
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              for="old_password"
              class="col-form-label">現在のパスワード</label>
            <validation-provider
              ref="old_password" 
              v-slot="v"
              name="現在のパスワード"
              rules="password|required">
              <b-form-input
                v-model="old_password"
                type="password" />
              <p class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              for="new_password1"
              class="col-form-label">新しいパスワード</label>
            <validation-provider
              ref="new_password1" 
              v-slot="v"
              name="新しいパスワード" 
              rules="password|required">
              <b-form-input
                v-model="new_password1"
                type="password" />
              <p class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              for="new_password2"
              class="col-form-label">新しいパスワード（確認）</label>
            <validation-provider
              ref="new_password2"
              v-slot="v"  
              name="新しいパスワード（確認）"
              rules="confirmed:new_password2"
              vid="new_password2">
              <b-form-input
                v-model="new_password2"
                type="password" />
              <p class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="general-form__btn row mt-5">
            <div class="col-6">
              <router-link
                to="/settings/">
                <button
                  type="button"
                  class="btn btn-block btn-cancel">
                  キャンセル
                </button>
              </router-link>
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-primary"
                @click="observer.passes(onClickSave)">
                保存
              </button>
            </div>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      old_password: '',
      new_password1: '',
      new_password2: ''
    }
  },
  methods: {
    async onClickSave() {

      this.$store.commit('startLoading')
      this.$axios.post('/auth/password/change/', {old_password: this.old_password, new_password1: this.new_password1, new_password2: this.new_password2})
        .then(() => {
          this.$store.commit('notify/set', {message: 'パスワードの更新が完了しました。'})
          this.$router.push('/settings/')
        })
        .catch((e) => {
          if (e.response && e.response.data){
            if (e.response.data.oldPassword){
              this.$refs.old_password.applyResult({
                errors: e.response.data.oldPassword,
                valid: false,
                failedRules: {}
              })
            }
            if (e.response.data.newPassword1){
              this.$refs.new_password1.applyResult({
                errors: e.response.data.newPassword1,
                valid: false,
                failedRules: {}
              })
            }
            if (e.response.data.newPassword2){
              this.$refs.new_password2.applyResult({
                errors: e.response.data.newPassword2,
                valid: false,
                failedRules: {}
              })
            }
          } else {
            this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
          }
        }).finally(() => {
          this.$store.commit('finishLoading')
        })
    }, 
  }
}
</script>
<style lang="scss" scoped>
.mypage{
  &__head{
    background-color: $primary;
    color: $white;
    border-radius: 8px;
  }
  &__img{
    object-fit: cover; 
    width: 60px;
    height: 60px;
    max-width: 60px;
    
  }
  &__name{
    font-weight: bold;
  }
  &__title{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
  &__team{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
}

.form-info{
  color: $grey09;
  &__logout{
    text-decoration: none;
    font-weight: bold;
    color: $grey09;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
}
</style>